export enum FeatureType {
	Boolean = "boolean",
	Metered = "metered",
	CreditSystem = "credit_system",
	AiCreditSystem = "ai_credit_system",
}

export enum AggregateType {
	Sum = "sum",
}

export enum FeatureUsageType {
	Single = "single_use",
	Continuous = "continuous_use",
}
